export default [
  {
    path: '/blockchain_network',
    name: 'NetworkView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/NetworkView.vue'
      ),
    meta: { title: 'Blockchain Network', group: 'settings' },
  },
  {
    path: '/user_registration',
    name: 'AccountView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/AccountView.vue'
      ),
    meta: { title: 'User Registration', group: 'settings' },
  },
  {
    path: '/api-keys',
    name: 'APIKeysView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/APIKeysView.vue'
      ),
    meta: { title: 'API Keys', group: 'settings' },
  },
  {
    path: '/system_wallet',
    name: 'SystemWalletView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/SystemWalletView.vue'
      ),
    meta: { title: 'System Wallet', group: 'settings' },
  },
  {
    path: '/group_management',
    name: 'GroupView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/GroupView.vue'
      ),
    meta: {
      title: 'Group Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/role_management',
    name: 'RoleView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/RoleView.vue'
      ),
    meta: {
      title: 'Role Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/permission_management',
    name: 'PermissionCodeView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/PermissionCodeView.vue'
      ),
    meta: {
      title: 'Permission Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/audit_log',
    name: 'AuditLogView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/AuditLogView.vue'
      ),
    meta: {
      title: 'Audit Log',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/login_history',
    name: 'LoginHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/LoginHistoryView.vue'
      ),
    meta: {
      title: 'Login History',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/threshold_settings',
    name: 'ThresholdSettingView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/ThresholdSettingView.vue'
      ),
    meta: {
      title: 'Threshold Settings',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/two_factor',
    name: 'TwoFASettingView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/TwoFASettingView.vue'
      ),
    meta: { title: 'Two-Factor Authentication', group: 'settings' },
  },
  {
    path: '/security_keys',
    name: 'WebAuthnSettingView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/WebAuthnSettingView.vue'
      ),
    meta: { title: 'Security Keys (WebAuthn)', group: 'settings' },
  },
  {
    path: '/preferences',
    name: 'PreferencesView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/PreferencesView.vue'
      ),
    meta: { title: 'Preferences', group: 'settings' },
  },
  {
    path: '/session_management',
    name: 'SessionManagementView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/SessionManagementView.vue'
      ),
    meta: { title: 'Session Management', group: 'settings' },
  },
  {
    path: '/ip_whitelist',
    name: 'IPWhitelistView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/IPWhitelistView.vue'
      ),
    meta: {
      title: 'IP Whitelist',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/health_check',
    name: 'HealthCheckView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/HealthCheckView.vue'
      ),
    meta: { title: 'System Health', group: 'settings' },
  },
  {
    path: '/notification_preferences',
    name: 'NotificationPreferencesView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/NotificationPreferencesView.vue'
      ),
    meta: { title: 'Notification Preferences', group: 'settings' },
  },
  {
    path: '/withdraw_stats',
    name: 'WithdrawStatsView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/WithdrawStatsView.vue'
      ),
    meta: {
      title: 'Withdraw Statistics',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/api_stats',
    name: 'ApiStatsView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/ApiStatsView.vue'
      ),
    meta: {
      title: 'API Statistics',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/multisig_settings',
    name: 'MultisigSettingsView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/MultisigSettingsView.vue'
      ),
    meta: {
      title: 'Multisig Settings',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/contract_deploy',
    name: 'ContractDeployView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/ContractDeployView.vue'
      ),
    meta: { title: 'Contract Deploy', group: 'settings' },
  },
  {
    path: '/deploy_history',
    name: 'DeployHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/DeployHistoryView.vue'
      ),
    meta: { title: 'Deploy History', group: 'settings' },
  },
  {
    path: '/wallet_monitor',
    name: 'WalletMonitorView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/WalletMonitorView.vue'
      ),
    meta: {
      title: 'Wallet Monitor',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/anomaly_detection',
    name: 'AnomalyDetectionView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/AnomalyDetectionView.vue'
      ),
    meta: {
      title: 'Anomaly Detection',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/backup_monitor',
    name: 'BackupMonitorView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/BackupMonitorView.vue'
      ),
    meta: {
      title: 'Backup Monitor',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/price_alerts',
    name: 'PriceAlertView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/PriceAlertView.vue'
      ),
    meta: {
      title: 'Price Alerts',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/scheduled_reports',
    name: 'ScheduledReportsView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/ScheduledReportsView.vue'
      ),
    meta: {
      title: 'Scheduled Reports',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
]
